<template>
  <div class="top-right">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.top-right {
  position: absolute;
  right: 3px;
  top: 3px;
  z-index: 100;
}
</style>
